import {
  doOpenNotePage,
  doOpenTicketPage,
  doOpenForwardPageExpanded,
} from 'actions/pages'
import {
  makeSelectTicketReplyDraftBodyPlainText,
  makeSelectTicketNoteDraftBodyPlainText,
  makeSelectDraftIsForwardedForTicketList,
} from 'ducks/drafts'
import { selectPrefersExpandedReplyHeader } from 'selectors/app'
import { selectHasTicketLoadedChangesets } from 'selectors/currentChangesets'
import metrics from 'util/metrics'

function buildPageAction(
  ticketId,
  hasReply = false,
  hasNote = false,
  isForwarding = false,
  prefersExpandedReplyHeader = false
) {
  if (hasNote && !hasReply) return doOpenNotePage(ticketId)
  return isForwarding
    ? doOpenForwardPageExpanded(ticketId)
    : doOpenTicketPage(ticketId, { expand: prefersExpandedReplyHeader })
}

export const doNavigateToTicket = ticketId => (dispatch, getState) => {
  const state = getState()

  try {
    const hot = selectHasTicketLoadedChangesets(state, ticketId)
    metrics.startTimer(`ticket-load-${ticketId}`, {
      ticketId,
      metric: 'ticket-load',
      logname: 'main',
      hot,
    })
  } catch (e) {
    // pass
  }

  const selectNoteDraftBodyPlainText = makeSelectTicketNoteDraftBodyPlainText(
    ticketId
  )
  const selectReplyDraftBodyPlainText = makeSelectTicketReplyDraftBodyPlainText(
    ticketId
  )
  const selectIsForwarding = makeSelectDraftIsForwardedForTicketList(ticketId)

  const prefersExpandedReplyHeader = selectPrefersExpandedReplyHeader(state)
  const isForwarding = selectIsForwarding(state)
  const noteDraftBodyPlainText = selectNoteDraftBodyPlainText(state)
  const replyDraftBodyPlainText = selectReplyDraftBodyPlainText(state)

  const hasReply = Boolean(
    replyDraftBodyPlainText && replyDraftBodyPlainText.trim()
  )
  const hasNote = Boolean(
    noteDraftBodyPlainText && noteDraftBodyPlainText.trim()
  )

  const action = buildPageAction(
    ticketId,
    hasReply,
    hasNote,
    isForwarding,
    prefersExpandedReplyHeader
  )

  return dispatch(action)
}
